import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import Search from "../../resources/search.png";
import logo from "../../resources/logo_normal.png";

import subMenu from "../../resources/subMenu.png";

import smallLogo from "../../resources/smallLogo.png";
import docLogo from "../../resources/docLogo.png";
import checked from "../../resources/checked.png";
import check from "../../resources/check.png";

import imgMenu1 from "../../resources/imgMenu1.png";
import imgMenu2 from "../../resources/imgMenu2.png";
import imgMenu3 from "../../resources/imgMenu3.png";
import imgMenu4 from "../../resources/imgMenu4.png";

export const Headers = styled.header`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 312px;
  border-bottom: 1px solid #fb9a9b;
  background-color: var(--headerBgColor);
  transition: 0.2s;
  height: 70px;
  trasition: 0.2s;
  & > ul {
    width: 30%;
    top:10px;
  }
  & > ul > li {
    font-size: 18px;
    line-height:44px;
    height:44px;
  }
  & > form {
    display: none;
  }

  @media only screen and (max-width: 1400px) {
    & > ul {      
      width: 100%;
      top:70px;
    }    
  }



  // ${(props) =>
    props.detail &&
    css`
      //     height:70px;
      //     trasition: 0.2s;
      //     &>ul{
      //         width:55%;
      //         top:17px;
      //     }
      //     &>ul>li{
      //         font-size:30px;
      //     }
      //     &>form{
      //         display:none;
      //     }
      //
    `}
  // ${(props) =>
    props.detail !== true &&
    css`
      // &.detailHeader{
      //     height:150px;
      //     trasition: 0.2s;
      //     &>ul{
      //         width:55%;
      //         top:17px;
      //     }
      //     &>ul>li{
      //         font-size:30px;
      //     }
      //     &>form{
      //         top:21px;
      //     }
      // }
    `}
 

`;


export const List = styled.ul`
  display: flex;  
  position: relative;
  width: 1050px;
  height: 45px;
  top: 10px;
  margin: 0 auto;  
  flex-direction: row;  
  justify-content: space-around;
  

  @media only screen and (max-width: 1400px) {    
    
    background-color:#fff;
    height: 100vh;
    width: 100%;
    z-index:99;    
    display:grid;
    grid-template-columns:repeat(1, 1fr);                

    top:0;
    left: 0;
    transition: transform 0.3s ease-in-out;

    transform: ${(props) => (props.toggle ? 'translateX(0)' : 'translateX(100%)')};
    height: 100vh;
    margin-top: -70px;

  }



`;


export const StyledBurger = styled.button`
  position: absolute;
  top: 25%;
  right: 2rem;
  display: flex;
  visibility: hidden;

  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;

  &:focus {
    outline: none;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background: ${({ open }) => open ? '#EFFFFA' : '#EFFFFA'};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    :nth-child(2) {
      opacity: ${({ open }) => open ? '0' : '1'};
      transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
    }

    :nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }



    @media only screen and (max-width: 1400px) {    
      visibility: visible;
    }

  }
`


export const Item = styled.li`
  height: 44px;
  text-align: center;
  color: ${(props) => (props.current ? "#443f3f" : "#ffffff")};
  font-size: 22px;
  font-family: HYGothicM;
  &:hover {
    color: #443f3f;
  }
  transition: background-color 0.5s ease;
  z-index: 99;
`;

export const MenuLink = styled(Link)`
  height: 45px;
  display: flex;
  align-itmes: center;
  justify-content: center;

  @media only screen and (max-width: 1400px) {
  background-color:#fff;
  color:#000;
  }




`;

export const SubMenuWrapper = styled.div`
  width: 250px;
  height: 50px;
  top: 20px;
  right: 9%;
  display: flex;
  position: absolute;

  & > a {
    margin-left: 13px;
  }

  @media only screen and (max-width: 1400px) {
    display:none;
  }

`;


export const Menu1 = styled.div`
  width: 26px;
  height: 24px;
  background: url(${subMenu}) no-repeat -27px -15px;
  background-size: auto;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
  :hover:before {
    content: "고객센터";
    font-size: 11px;
    color: #ffffff;
    position: absolute;
    bottom: 5px;
    left: 0;
    z-index: 9999;
  }
`;

export const Menu2 = styled.div`
  width: 25px;
  height: 25px;
  background: url(${subMenu}) no-repeat -70px -13px;
  background-size: auto;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
  &:hover:before {
    content: "폰트";
    font-size: 11px;
    color: #ffffff;
    position: absolute;
    bottom: 5px;
    left: 50px;
    z-index: 9999;
  }
`;

export const Menu3 = styled.div`
  width: 26px;
  height: 25px;
  background: url(${subMenu}) no-repeat -240px -13px;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
  &:hover:before {
    content: "폰트매니져";
    font-size: 11px;
    color: #ffffff;
    position: absolute;
    bottom: 5px;
    left: 80px;
    z-index: 9999;
  }
`;

export const Menu4 = styled.div`
  width: 29px;
  height: 29px;
  background: url(${subMenu}) no-repeat -197px -15px;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
  &:hover:before {
    content: "로그인";
    font-size: 11px;
    color: #ffffff;
    position: absolute;
    bottom: 5px;
    left: 130px;
    z-index: 9999;
  }
`;

export const DocsLink = styled.div`
  width: 50px;
  height: 51px;
  background-image: url(${docLogo});
  background-size: contain;
  position: absolute;
  top: 6px;
  right: 19%;
`;

export const Logo = styled.div`
  width: 80px;
  height: 36px;
  background-image: url(${logo});
  background-size: cover;
  cursor: pointer;
  position: absolute;
  top: 15px;
  left: 17%;

  @media only screen and (max-width: 1400px) {
    top: 15px;
    left: 5%;
  }

`;

export const SearchBox = styled.form`
  border: 2px solid white;
  position: relative;
  top: 142px;
  width: 652px;
  height: 60px;
  padding: 9px;
  display: grid;
  margin: 0 auto;
  grid-template-columns: 157px 1fr;
  z-index: 2;
  // @media only screen and (max-width: 768px) {
  //     width:100%;
  //     top:140px;
  // }
  // @media only screen and (max-width: 500px) {
  //     top:172px;
  // }
`;

export const ComboWrapper = styled.div`
  width: 180px;
  overflow: hidden;
`;

export const Combo = styled.select`
    width:100%;
    height:100%;
    /*background-color:var(--headerBgColor);*/
    background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right #ddd;
    -webkit-appearance: none;
    background-position-x: 244px
    border:none;
    color:white;
    font-family:hy1148100115;
    font-size:16px;
    padding:3px;
    
    
    /*
    &:focus{
        outline:white solid 1px;
    }
    */
`;

export const Options = styled.option`
  background-color: white;
  color: #575859;
  line-height: 20px;
`;

export const Keyword = styled.input`
  width: 100%;
  margin: 0 auto;
  border: none;
  padding: 10px;

  &:focus {
    outline: none;
  }
`;

export const BtnClearKeyword = styled.input`
  position: absolute;
  top: 15px;
  right: 60px;
  font-size: 20px;
  border: none;
  background-color: white;
  outline: 0;
  cursor: pointer;
`;

export const SearchBtn = styled.button`
  position: absolute;
  top: 15px;
  right: 28px;
  width: 24px;
  height: 25px;
  background-image: url(${Search});
  border: none;
  background-color: white;
  cursor: pointer;
  outline: 0;
`;
export const DepthContainer = styled.div`
  position: relative;
  width: 850px;
  height: 20px;
  top: 130px;
  margin-left: 465px;
  display: grid;
  grid-template-columns: 105px 85px 70px 60px 60px 70px 80px 85px 50px;
  grid-row-auto: 20px;
  color: white;
  transition: 0.2s;

  input[type="checkbox"] {
    display: none;
  }
  input[type="checkbox"] + label {
    cursor: pointer;
  }
  input[type="checkbox"] + label span {
    display: inline-block;
    width: 17px;
    height: 17px;
    margin-right: 2px;
    vertical-align: middle;
    background: url(${(props) => (props.state ? checked : check)});
    cursor: pointer;
  }
  ${(props) =>
    props.detail &&
    css`
      top: 0px;
      color: black;
      input[type="checkbox"] + label span {
        border: 2px solid black;
      }
    `}
`;

export const DepthCheckbox = styled.input`
  &[type="checkbox"] {
    display: none;
  }
  padding: 0;
  margin: 0;
  width: 17px;
  height: 17px;
  margin-right: 2px;

  cursor: pointer;
  &:checked {
  }
`;
export const DepthCheckLabel = styled.label`
  position: relative;
  top: -4px;
  height: 17px;
  font-family: var(--hyGothic);
  font-size: 13px;
  cursor: pointer;
`;
